import { render, staticRenderFns } from "./scrolltop.component.vue?vue&type=template&id=1f59b77d&scoped=true&lang=html&"
import script from "./scrolltop.component.vue?vue&type=script&lang=js&"
export * from "./scrolltop.component.vue?vue&type=script&lang=js&"
import style0 from "./scrolltop.component.vue?vue&type=style&index=0&id=1f59b77d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f59b77d",
  null
  
)

export default component.exports